import { watch } from "vue";
import { useAppsStore } from "@/pinia/appsStore";

export const useAppInit = () => {
  const appsStore = useAppsStore();

  watch(
    () => appsStore.app?.id,
    (id, prevId) => {
      if (!id || id === prevId) return;
      appsStore.getAppTemplates(id);
      appsStore.getAppSequenceTemplates(id);
    },
    { immediate: true },
  );
};
